import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFeedingSiloList as getFeedingSiloListApi,
	getFeedingSilo as getFeedingSiloApi,
	addNewFeedingSilo as addNewFeedingSiloApi,
	updateFeedingSilo as updateFeedingSiloApi,
	deleteFeedingSilo as deleteFeedingSiloApi,
} from '../../helpers/establishment/backend_helper';

export const getFeedingSiloList = createAsyncThunk('feedingSilo/getFeedingSiloList', async (params) => {
	try {
		const response = getFeedingSiloListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFeedingSilo = createAsyncThunk('feedingSilo/getFeedingSilo', async feedingSilo_id => {
	try {
		const response = getFeedingSiloApi(feedingSilo_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFeedingSilo = createAsyncThunk('feedingSilo/addNewFeedingSilo', async feedingSilo => {
	try {
		const response = addNewFeedingSiloApi(feedingSilo);
		toast.success('Silo de Alimento agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar feedingSilo.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFeedingSilo = createAsyncThunk('feedingSilo/updateFeedingSilo', async (feedingSilo) => {
		try {
			const response = updateFeedingSiloApi(feedingSilo);
			toast.success('Silo de Alimento actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar feedingSilo.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFeedingSilo = createAsyncThunk('feedingSilo/deleteFeedingSilo', async feedingSilo => {
	try {
		const response = await deleteFeedingSiloApi(feedingSilo);
		toast.success('Silo de Alimento eliminado exitosamente.', { autoClose: 3000 });
		return { feedingSilo, ...response };
	} catch (error) {
		toast.error('Error al eliminar feedingSilo.', { autoClose: 3000 });
		throw new Error(error);
	}
});


